(function () {
  if (window.productStickyCartController) {
    window.productStickyCartController.init(document);
    return;
  }

  var instances = new WeakMap();

  function initBar(bar) {
    if (instances.has(bar)) return;

    var sectionId = bar.dataset.sectionId;
    var section = bar.closest('.shopify-section') || document;
    var form = document.getElementById('product-form-' + sectionId);
    var mainButton = form && form.querySelector('[name="add"]');
    var stickyButton = bar.querySelector('[data-sticky-add]');
    var stickyPrice = bar.querySelector('[data-sticky-price]');
    var stickyColor = bar.querySelector('[data-sticky-color]');
    var stickyQuantity = bar.querySelector('[data-sticky-quantity]');
    var stickyToggle = bar.querySelector('[data-sticky-toggle]');
    var mainQuantity = document.getElementById('Quantity-' + sectionId);
    var price = document.getElementById('price-' + sectionId);
    var picker = section.querySelector('variant-radios, variant-selects');

    if (!form || !mainButton || !stickyButton || !stickyQuantity) return;

    if (!mainQuantity) {
      mainQuantity = document.createElement('input');
      mainQuantity.type = 'hidden';
      mainQuantity.name = 'quantity';
      mainQuantity.value = '1';
      form.appendChild(mainQuantity);
    }

    function validQuantity(value) {
      var quantity = Number.parseInt(value, 10);
      return Number.isFinite(quantity) && quantity > 0 ? quantity : 1;
    }

    function syncQuantityFromMain() {
      stickyQuantity.value = validQuantity(mainQuantity.value);
    }

    function syncQuantityToMain(normalize) {
      var quantity = Number.parseInt(stickyQuantity.value, 10);
      if (!Number.isFinite(quantity) || quantity < 1) {
        if (!normalize) return;
        quantity = 1;
      }
      if (normalize) stickyQuantity.value = quantity;
      if (mainQuantity.value !== String(quantity)) {
        mainQuantity.value = quantity;
        mainQuantity.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }

    function mainColorControl() {
      if (!picker || !stickyColor) return null;
      var index = Number(stickyColor.dataset.optionIndex);
      if (picker.matches('variant-radios')) {
        return picker.querySelectorAll('fieldset')[index];
      }
      return picker.querySelectorAll('select')[index];
    }

    function syncColorFromMain() {
      var control = mainColorControl();
      if (!control) return;
      var selected = control.matches('fieldset')
        ? control.querySelector('input[type="radio"]:checked')
        : control;
      if (selected) stickyColor.value = selected.value;
    }

    function syncColorToMain() {
      var control = mainColorControl();
      if (!control) return;
      if (control.matches('fieldset')) {
        var radio = Array.from(control.querySelectorAll('input[type="radio"]')).find(function (input) {
          return input.value === stickyColor.value;
        });
        if (radio && !radio.checked) {
          radio.checked = true;
          radio.dispatchEvent(new Event('change', { bubbles: true }));
        }
      } else if (control.value !== stickyColor.value) {
        control.value = stickyColor.value;
        control.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }

    function syncPrice() {
      if (!price || !stickyPrice) return;
      if (price.classList.contains('visibility-hidden')) {
        stickyPrice.textContent = '';
        return;
      }
      var priceElement = price.querySelector('.price--on-sale .price-item--sale') ||
        price.querySelector('.price__regular .price-item--regular');
      if (priceElement) stickyPrice.textContent = priceElement.textContent.trim();
    }

    function syncButton() {
      var loading = mainButton.classList.contains('loading');
      stickyButton.disabled = mainButton.disabled ||
        mainButton.getAttribute('aria-disabled') === 'true' ||
        loading;
      stickyButton.classList.toggle('loading', loading);
      stickyButton.setAttribute('aria-busy', String(loading));
      var stickySpinner = stickyButton.querySelector('.loading-overlay__spinner');
      if (stickySpinner) stickySpinner.classList.toggle('hidden', !loading);
      var mainLabel = mainButton.querySelector('span');
      var stickyLabel = stickyButton.querySelector('.product-sticky-cart__add-label');
      if (mainLabel && stickyLabel) stickyLabel.textContent = mainLabel.textContent.trim();
    }

    function updateBarHeight() {
      var toggleHeight = stickyToggle && getComputedStyle(stickyToggle).display !== 'none'
        ? stickyToggle.getBoundingClientRect().height
        : 0;
      document.body.style.setProperty('--product-sticky-cart-height', bar.getBoundingClientRect().height + toggleHeight + 'px');
    }

    function onToggle() {
      var collapsed = bar.classList.toggle('is-collapsed');
      stickyToggle.setAttribute('aria-expanded', String(!collapsed));
      stickyToggle.querySelector('[data-sticky-toggle-label]').textContent = collapsed ? '開く' : '閉じる';
      updateBarHeight();
    }

    function updateVisibility() {
      var header = document.querySelector('.header_original');
      var headerBottom = header && getComputedStyle(header).position === 'fixed'
        ? Math.max(0, header.getBoundingClientRect().bottom)
        : 0;
      var footer = document.getElementById('shopify-section-footer');
      var footerRect = footer && footer.getBoundingClientRect();
      var footerVisible = footerRect && footerRect.top < window.innerHeight && footerRect.bottom > 0;
      var show = mainButton.getBoundingClientRect().bottom <= headerBottom && !footerVisible;
      if (!show && bar.contains(document.activeElement)) mainButton.focus({ preventScroll: true });
      bar.classList.toggle('is-visible', show);
      bar.inert = !show;
      bar.setAttribute('aria-hidden', String(!show));
      document.body.classList.toggle('has-product-sticky-cart', show);
      if (show) updateBarHeight();
      else document.body.style.removeProperty('--product-sticky-cart-height');
    }

    function onQuantityStep(event) {
      var button = event.target.closest('[data-sticky-quantity-step]');
      if (!button) return;
      if (button.dataset.stickyQuantityStep === 'plus') stickyQuantity.stepUp();
      else stickyQuantity.stepDown();
      syncQuantityToMain(true);
    }

    function onStickyAdd() {
      syncQuantityToMain(true);
      if (!stickyButton.disabled) {
        mainButton.click();
        syncButton();
      }
    }

    var buttonObserver = new MutationObserver(syncButton);
    buttonObserver.observe(mainButton, { attributes: true, childList: true, characterData: true, subtree: true });

    var priceObserver = null;
    if (price) {
      priceObserver = new MutationObserver(syncPrice);
      priceObserver.observe(price, { attributes: true, childList: true, characterData: true, subtree: true });
    }

    var barSizeObserver = null;
    if (typeof ResizeObserver !== 'undefined') {
      barSizeObserver = new ResizeObserver(function () {
        if (bar.classList.contains('is-visible')) updateBarHeight();
      });
      barSizeObserver.observe(bar);
    }

    var visibilityFrame = null;
    function scheduleVisibilityUpdate() {
      if (visibilityFrame !== null) return;
      visibilityFrame = requestAnimationFrame(function () {
        visibilityFrame = null;
        updateVisibility();
      });
    }
    window.addEventListener('scroll', scheduleVisibilityUpdate, { passive: true });

    bar.addEventListener('click', onQuantityStep);
    stickyButton.addEventListener('click', onStickyAdd);
    if (stickyToggle) stickyToggle.addEventListener('click', onToggle);
    stickyQuantity.addEventListener('input', onStickyQuantityInput);
    stickyQuantity.addEventListener('change', onStickyQuantityChange);
    mainQuantity.addEventListener('input', syncQuantityFromMain);
    mainQuantity.addEventListener('change', syncQuantityFromMain);
    if (stickyColor && picker) {
      stickyColor.addEventListener('change', syncColorToMain);
      picker.addEventListener('change', syncColorFromMain);
    }
    window.addEventListener('resize', scheduleVisibilityUpdate);

    function onStickyQuantityInput() { syncQuantityToMain(false); }
    function onStickyQuantityChange() { syncQuantityToMain(true); }

    syncQuantityFromMain();
    syncColorFromMain();
    syncPrice();
    syncButton();
    updateVisibility();

    instances.set(bar, function () {
      buttonObserver.disconnect();
      if (priceObserver) priceObserver.disconnect();
      if (barSizeObserver) barSizeObserver.disconnect();
      window.removeEventListener('scroll', scheduleVisibilityUpdate);
      window.removeEventListener('resize', scheduleVisibilityUpdate);
      if (visibilityFrame !== null) cancelAnimationFrame(visibilityFrame);
      document.body.classList.remove('has-product-sticky-cart');
      document.body.style.removeProperty('--product-sticky-cart-height');
      instances.delete(bar);
    });
  }

  function init(root) {
    if (root.matches && root.matches('.product-sticky-cart')) initBar(root);
    root.querySelectorAll('.product-sticky-cart').forEach(initBar);
  }

  window.productStickyCartController = { init: init };
  init(document);
  document.addEventListener('shopify:section:load', function (event) { init(event.target); });
  document.addEventListener('shopify:section:unload', function (event) {
    event.target.querySelectorAll('.product-sticky-cart').forEach(function (bar) {
      var destroy = instances.get(bar);
      if (destroy) destroy();
    });
  });
})();
